<template>
    <v-dialog v-model="dialog" max-width="480px" style="z-index: 10000;" scrollable>
        <v-card v-if="device != null" style="overflow: hidden;">
            <v-toolbar dark color="cyan darken-3" dense>
                <v-toolbar-title>{{videoName}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="close()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-row v-if="showMe" style="height:350px;">
                <v-col cols="12" align="start">
                    <v-container
                            fluid>
                        <v-row align="center"
                               justify="center">
                            <v-col cols="12">
                                <v-card flat>
                                    <div class="moveableContainer" :key="mcIndex" :style="getStyle()">
                                        <img contain :src="getBackgroundImageUrl(device)"
                                             style="max-height:320px;max-width:376px;position: absolute;">
                                        <Moveable
                                                :style="getStyleMonitor()"
                                                v-bind="moveable"
                                                class="moveable"
                                                @drag="handleDrag"
                                                @resize="handleResize"
                                                @scale="handleScale"
                                                @rotate="handleRotate"
                                                @warp="handleWarp">
                                            <div class="monitor"></div>
                                        </Moveable>
                                    </div>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-col>
            </v-row>
            <v-card-actions>
                <v-row  justify="end">
                    <v-col cols="12">
                        <v-btn @click="setMonitor" color="cyan darken-3" block outlined>update</v-btn>
                    </v-col>
                    <v-col cols="12">
                        <v-btn @click="resetMonitor" color="cyan darken-3" block outlined>reset</v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    // import Vue from 'vue'
    import Moveable from 'vue-moveable';
    import Vue from "vue";

    export default {
        name: 'DialogShowVideo',
        components: {Moveable},
        props: [''],
        data() {
            return {
                mcIndex: 1,
                jsonData: null,
                dialog: false,
                showMe: false,
                videoName: '',
                device: null,
                moveable: {
                    id: 1111,
                    draggable: true,
                    throttleDrag: 0,
                    resizable: true,
                    throttleResize: 1,
                    keepRatio: true,
                    scalable: false,
                    throttleScale: 0,
                    rotatable: false,
                    throttleRotate: 0
                }
            }
        },
        methods: {
            open: function (device) {
                this.showMe = false
                this.device = device
                console.log('device', this.device)
                if (this.device.jsonMonitor) {
                    try {
                        this.device.jsonMonitor = JSON.parse(this.device.jsonMonitor)
                        if (this.device.jsonMonitor) {
                            if (this.device.jsonMonitor.pos) {
                                this.device.xx = this.device.jsonMonitor.pos.x
                                this.device.yy = this.device.jsonMonitor.pos.y
                                this.device.width = this.device.jsonMonitor.pos.w
                                this.device.height = this.device.jsonMonitor.pos.h
                            }
                        }
                    } catch (error) {
                        console.log('error', error)
                    }
                }
                // 2160×3840
                console.log(device.orientation, this.device.width, this.device.height)
                if(this.device.height === 'NaN' || this.device.width === 'NaN') {
                    this.device.width = 90
                    this.device.height = 10
                }
                var a = this.device.width / this.device.height
                var b = 0
                if (device.orientation === 'horizontal') {
                    b = 3840 / 2160
                    console.log(a, b, (a - b))
                    if ( Math.abs(a - b) > 0.1 ) {
                        this.device.width = 3840 * 0.1
                        this.device.height = 2160 * 0.1
                    }
                } else {
                    b = 2160 / 3840
                    console.log(a, b)
                    if ( Math.abs(a - b) > 0.1 ) {
                        this.device.width = 2160 * 0.1
                        this.device.height = 3840 * 0.1
                    }
                }
                console.log('start', this.device.xx)
                this.moveable.style = this.getStyleMonitor()
                this.dialog = true
                this.mcIndex = this.mcIndex + 1
                var cmp = this
                window.setTimeout(function () {
                    cmp.showMe = true
                }, 300)
            },
            getBackgroundImageUrl: function (item) {
                var url = Vue.prototype.$config.HOST + '/media/devices/' + item.guid + '/' + item.imgBackground
                if (item.imgBackground === 'none') {
                    url = '/static/DER-hoch.jpg'
                }
                console.log('getBackgroundImageUrl', url)
                return url
            },
            handleDrag({target, left, top}) {
                console.log('onDrag left, top', left, top);
                target.style.left = `${left}px`;
                target.style.top = `${top}px`;
                this.device.style = target.style
                this.device.xx = left
                this.device.yy = top
            },
            getStyle() {
                var css = ''
                // height:400px;background-repeat:no-repeat !important; background: url("/static/Standort.png") no-repeat center center; background-size: 100% 400px contain;'
                // -webkit-background-size: 350px;-moz-background-size: 350px;-o-background-size: 350px;background-size: 350px;
                return css
            },
            getStyleMonitor() {
                var css = 'left:' + this.device.xx + 'px'
                css += ';top:' + this.device.yy + 'px;z-index:1000;'
                css += 'width:' + this.device.width + 'px;'
                css += 'height:' + this.device.height + 'px;'
                console.log('getStyleMonitor', css)
                return css
            },
            handleResize({target, width, height, delta}) {
                console.log('onResize', width, height);
                delta[0] && (target.style.width = `${width}px`);
                delta[1] && (target.style.height = `${height}px`);
                this.device.width = width
                this.device.height = height
            },
            handleScale({target, transform, scale}) {
                console.log('onScale scale', scale);
                target.style.transform = transform;
            },
            handleRotate({target, dist, transform}) {
                console.log('onRotate', dist);
                target.style.transform = transform;
            },
            handleWarp({target, transform}) {
                console.log('onWarp', target);
                target.style.transform = transform;
            },
            onConfigSaved(s) {
                console.log('onConfigSaved', s)
                this.close()
            },
            close() {
                this.showMe = false
                this.dialog = false
                this.$emit('onClose', this.jsonData)
            },
            resetMonitor() {
                console.log('resetMonitor')
                var di = this.device
                var json = {
                    guid: di.guid,
                    jsonMonitor: {
                        vis: true,
                        pos: {
                            x: 0,
                            y: 0,
                            w: di.width,
                            h: di.height
                        }
                    }
                }
                this.jsonData = json.jsonMonitor
                Vue.prototype.$api.updateDeviceJSON(di.guid, json, this.onConfigSaved)
            },
            setMonitor() {
                console.log('setMonitor')
                var di = this.device
                var json = {
                    guid: di.guid,
                    jsonMonitor: {
                        vis: true,
                        pos: {
                            x: di.xx,
                            y: di.yy,
                            w: di.width,
                            h: di.height
                        }
                    }
                }
                this.jsonData = json.jsonMonitor
                Vue.prototype.$api.updateDeviceJSON(di.guid, json, this.onConfigSaved)
            }
        },
        mounted() {
        }
    }
</script>

<style scoped>
    .monitor {
        position: absolute;
        background-color: #2a2e34;
        color: white;
    }

    .monitor video {
        width: auto !important;
        object-fit: fill;
    }

    .moveableContainer {
        position: absolute;
        left: 0px;
        right: 0px;
        height: 400px;

    }

    .frame {
        border: 0;

        -ms-transform: scale(0.62);
        -moz-transform: scale(0.62);
        -o-transform: scale(0.62);
        -webkit-transform: scale(0.62);
        transform: scale(0.62);

        -ms-transform-origin: 0 0;
        -moz-transform-origin: 0 0;
        -o-transform-origin: 0 0;
        -webkit-transform-origin: 0 0;
        transform-origin: 0 0;
    }
</style>
